partiu<template>
    <div class="splash-container" :style="{ background: SplashScreenParams.background }">
        <div class="splash-content">
            <img class="splash-logo" :src="SplashScreenParams.mainLogoSrc" :alt="SplashScreenParams.mainLogoAlt" />
            <div class="splash-title">
                {{$t(SplashScreenParams.title)}}<br />
                {{$t(SplashScreenParams.subtitle)}}
            </div>
        </div>
        <div class="splash-bottom">
            <img class="splash-parceiro left" :src="SplashScreenParams.partnerLogoLeftSrc" :alt="SplashScreenParams.partnerLogoLeftAlt" />
            <img class="splash-parceiro right" :src="SplashScreenParams.partnerLogoRightSrc" :alt="SplashScreenParams.partnerLogoRightAlt" />
        </div>
        <div class="splash-version">
            {{ $t(SplashScreenParams.versionMessage) }} {{ SplashScreenParams.version }}
        </div>
    </div>
</template>

<script>
import { 
    SplashScreenParams
} from '../constants.js';
export default {
    name: 'SplashScreen',
    computed: {
        SplashScreenParams() {
            return SplashScreenParams;
        }
    }
};
</script>

<style scoped>
.splash-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    z-index: 9999;
    padding-top: 8vh;
}

.splash-content {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    height: 100%;
    padding-top: 4vh;
}

.splash-logo {
    height: 35vh;
    min-height: 35vh;
    width: auto;
    max-width: 50vw;
    object-fit: contain;
    border-radius: 32px;
    background: transparent;
    display: block;
    margin-bottom: 2vh;
}

.splash-title {
    color: #fff;
    font-size: 1.45rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15vh;
    line-height: 1.3;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}

.splash-bottom {
    width: 100%;
    max-width: 400px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 16px;
}

.splash-parceiro {
    height: 25vh;
    max-width: 40vw;
    min-height: 80px;
    min-width: 80px;
    object-fit: contain;
    background: transparent;
    border-radius: 8px;
    padding: 4px 12px;
}

.splash-parceiro.left {
    align-self: flex-start;
    height: 20vh;
    max-width: 28vw;
    min-height: 80px;
    min-width: 80px;
    padding: 14px 20px 0px 25px;
}

.splash-parceiro.right {
    align-self: flex-end;
    max-width: 45vw;
    min-height: 80px;
    min-width: 80px;
}

.splash-version {
    color: #ffffff;
    font-size: 0.85rem;
    text-align: right;
    width: 100%;
    opacity: 0.8;
    position: absolute;
    bottom: 48px;
    right: 24px;
    letter-spacing: 0.2px;
}

.bg-contrast {
    background-color: #ffffff;
}

@media (max-width: 600px) {
    .splash-container {
        padding-top: 6vh;
    }

    .splash-content {
        max-width: 95vw;
        margin-top: 0;
        justify-content: flex-start;
        padding-top: 2vh;
    }

    .splash-logo {
        height: 45vh;
        min-height: 45vh;
        width: auto;
        max-width: 70vw;
        margin-bottom: 2vh;
    }

    .splash-title {
        font-size: 1.45rem;
        margin-bottom: 12vh;
    }

    .splash-bottom {
        max-width: 95vw;
        bottom: 72px;
        padding: 0 4vw;
    }

    .splash-parceiro {
        height: 18vh;
        max-width: 40vw;
        min-height: 54px;
        min-width: 54px;
    }

    .splash-version {
        font-size: 0.75rem;
        right: 8px;
        bottom: 40px;
    }
}
</style>